export const LANGUAGE_STORAGE_KEY = "syntez25-language";
